/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{createMarkerTexture as r}from"../../support/engineContent/marker.js";import{ProceduralTextureRepository as e}from"./ProceduralTextureRepository.js";function o(o,t){return new e((e=>r(e,o)),(r=>r),t)}export{o as createMarkerTextureRepository};
